export default __webpack_public_path__ + "search-overview-header-960-ebfb7db89e1d3c7e25c5e5e67dc716d0.png";